namespace HA.Core.HTML {
    export class MenuItem extends Box {

        protected createSelf() {
            super.createSelf();
            this.addClass("menui");
            const cont = new FlexContainer();
            const logo = this.get("l");

            if (logo instanceof Object) {
                const img2 = new Div(toMap(logo));
                img2.addClass("medc");
                cont.appendChild(img2);
            } else {
                const img = new Div();
                img.addClass("medc");
                img.appendChild(new Img(toMap({src: logo})));
                cont.appendChild(img);
            }

            cont.appendChild(new TextField(this.get("n")));
            this.appendChild(cont);
        }
    }
}
